import React from 'react';
import styled from "styled-components"
import IsInsignia from '../../../Utils/IsInsignia'

const Button = styled.button`
    height: 42px;
    display: flex;
    align-items: center;
    justify-content : center;
    color:#003e8d;
    font-size: 14px;
    border-top: 1px solid rgba(214, 214, 214, 0.6);
    border-bottom: 1px solid rgba(214, 214, 214, 0.6);
    border-left: 0px;
    border-right: 0px;
    width: 100%;
    margin : 15px 0;
    cursor: pointer;
    background: none;

    color:  ${props=>IsInsignia()?'#cea05b': '#003e8d'};
  

    &.inactive{
        border-top: 1px solid rgba(214, 214, 214, 1);
        border-bottom: 1px solid rgba(214, 214, 214, 1);
        border-left: 0px;
        border-right: 0px;
        pointer-events: none;
        opacity: 0.4;
    }
    &:hover{
        background: #003e8d;
        color: #ffffff;
        border-radius: 5px;

        background:  ${props=>IsInsignia()?'#cea05b': '#003e8d'};
        color:  ${props=>IsInsignia()?'#ffffff': '#ffffff'};

    }
`

const LoginButton = (props) => (
        <Button className='login-button' onClick={props.toggleLoginScreen.bind(this,props.loginType,props.logout)}>Login Now</Button>
    );

export default LoginButton;

export {Button};

// height: 36px;
// display: flex;
// align-items: center;
// justify-content : center;
// color: #ffffff;
// font-weight: 500;
// font-size: 14px;
// border: 0;
// border-radius: 5px;
// box-shadow: none;
// outline: 0;
// width: 100%;
// margin : 15px 0;
// cursor: pointer;
// background: #003e8d;
// &.inactive{
//     pointer-events: none;
//     opacity: 0.2;
// }
// background:  ${props=>IsInsignia()?'linear-gradient(to bottom, #ffbd3d, #d39f3a 14%, #9a7121 38%, #5f481c)': '#003e8d'};